import style from './style.module.scss';
import { Modal } from 'antd';
import { Button } from '../button';
import CheckCircle from '../../icons/CheckCircleBlack.svg?react';
import CloseIcon from '../../icons/X.svg?react';

type PopupSuccessProps = {
    message: string;
    onClose: () => void;
};

export const PopupSuccess = ({ message, onClose }: PopupSuccessProps) => {
    return (
        <Modal
            open={true}
            cancelText={null}
            footer={null}
            closeIcon={<CloseIcon onClick={onClose} />}
        >
            <div className={style.modal_content}>
                <CheckCircle className={style.icon} />
                <div className={style.title}>Success!</div>
                <div className={style.text}>{message}</div>
            </div>
            <div className={style.button_container}>
                <Button variant="primary" onClick={onClose}>
                    OK
                </Button>
            </div>
        </Modal>
    );
};
